import cl from '@/utils/console/cl'
import urls from '@/utils/urls/urls'
import React from 'react'
import CountUpNumber from './CountUpNumber'
// import CountUp from 'react-countup'

const StatsCounter = async () => {
    const res = await fetch(urls?.stats)
    const data = await res.json()
    const stats =  Array.isArray(data?.data) ? data?.data : [];
    // cl("stats", stats)
    return (
        <div className="counter-area pt-40 pb-40">
            <div className="container">
                <div className="row g-4 justify-content-center">
                    {
                        stats?.slice(0, 4)?.map((stat: any, index: any) => (
                            <div className="col-md-6 col-lg-4 col-xl-3" key={index}>
                                <div className="counter-box wow fadeInUp" data-wow-delay=".25s">
                                    <div className="icon">
                                        <img src="../assets/img/icon/solar.svg" alt="" />
                                    </div>
                                    <div className="content">
                                        <div className="info">
                                            <span
                                                className="counter"
                                                data-count="+"
                                                data-to={parseInt(stat?.numbers)}
                                                data-speed={3000}
                                            >
                                                <CountUpNumber data={parseInt(stat?.numbers)} />
                                                {/* {stat?.numbers} */}
                                            </span>
                                            <span className="unit">{stat?.unit}</span>
                                        </div>
                                        <h6 className="title">{stat?.name}</h6>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                    {/* <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="counter-box wow fadeInUp" data-wow-delay=".25s">
                            <div className="icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="content">
                                <div className="info">
                                    <span
                                        className="counter"
                                        data-count="+"
                                        data-to={150}
                                        data-speed={3000}
                                    >
                                        150
                                    </span>
                                    <span className="unit">k</span>
                                </div>
                                <h6 className="title">Projects Done</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="counter-box wow fadeInDown" data-wow-delay=".25s">
                            <div className="icon">
                                <img src="../assets/img/icon/rating.svg" alt="" />
                            </div>
                            <div className="content">
                                <div className="info">
                                    <span
                                        className="counter"
                                        data-count="+"
                                        data-to={25}
                                        data-speed={3000}
                                    >
                                        25
                                    </span>
                                    <span className="unit">K</span>
                                </div>
                                <h6 className="title">Happy Clients</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="counter-box wow fadeInUp" data-wow-delay=".25s">
                            <div className="icon">
                                <img src="../assets/img/icon/staff.svg" alt="" />
                            </div>
                            <div className="content">
                                <div className="info">
                                    <span
                                        className="counter"
                                        data-count="+"
                                        data-to={120}
                                        data-speed={3000}
                                    >
                                        120
                                    </span>
                                    <span className="unit">+</span>
                                </div>
                                <h6 className="title">Experts Staff</h6>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-lg-4 col-xl-3">
                        <div className="counter-box wow fadeInDown" data-wow-delay=".25s">
                            <div className="icon">
                                <img src="../assets/img/icon/award.svg" alt="" />
                            </div>
                            <div className="content">
                                <div className="info">
                                    <span
                                        className="counter"
                                        data-count="+"
                                        data-to={50}
                                        data-speed={3000}
                                    >
                                        50
                                    </span>
                                    <span className="unit">+</span>
                                </div>
                                <h6 className="title">Win Awards</h6>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default StatsCounter
